import {EventPayload} from '../events';

export class ClearDataEvent implements EventPayload {
    data: any;
}
